import { useSelector, useDispatch, useStore } from "react-redux";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { useSortableListContainer } from "@uiview/views/AISaas/SortableList/container";
import { SortableToolbar } from "@uiview/views/AISaas/SortableList/components/SortableToolbar";
import css from "./index.module.scss";
import { useMemo, useRef } from "react";
import { SortableListUtil } from "@uiview/views/AISaas/SortableList/util";
import func from "@uikit/func";
import { fotActions } from "@store/fot";
import { feedActions } from "@store/feed";
import { useAISaasPreviewItem } from "@uiview/views/AISaas/hooks/useAISaasPreviewItem";
import { typeMap } from "@uiview/views/PreviewV2ToolBar/PreviewV2ToolBarUtil";
import { useHomeUsePluginContainer } from "@custom-hooks/HomeUsePluginRoot";
import { logEvent } from "@uikit/service/amplitude";

export function SortableItem<T>(props: SortableList.ItemProps<T>) {
  const dispatch = useDispatch();

  const editorImageScrollDireaction = useSelector((state: any) => state.fot.editorImageScrollDireaction);
  const setImageScrollDireaction = (val: any) => {
    dispatch(fotActions.setImageScrollDireaction(val));
  };

  const { onPreviewItemMouseEnter, onPreviewItemMouseLeave } = useAISaasPreviewItem();
  const {
    nodesState: { getNodes },
    saasAndThinkState: { setSaasUIData, saasUIDataRef, isClickAddToContent },
  } = useHomeUsePluginContainer();

  const { index, value, children, renderItemChildren, type } = props;
  const { onSwitch, disabled, listType } = useSortableListContainer();
  const { id, data } = value;
  const nodeData: any = { ...data };

  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({
    disabled: !id,
    id: id,
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };
  const sortableProps = { id, attributes, listeners, setNodeRef, style, type };

  const renderChild = () => {
    if (renderItemChildren) {
      return renderItemChildren({
        value,
        sortableProps,
        index,
      });
    }

    return children;
  };

  const SortableItemRef = useRef<HTMLDivElement>(null);
  // const rect = SortableItemRef.current?.getBoundingClientRect();

  const sortableItemId = SortableListUtil.generateDomIdAttr(id);

  const confirmDeleteBox = (id: any) => {
    let arr: any[] = [];
    // bsf-4912 replace thoughts
    const tempThoughts = saasUIDataRef.current.output;
    //  判断groupDnd有多个或者第一个的groupId如果存在 则表示是group
    if (nodeData?.groupDnd?.length > 1 || nodeData?.groupDnd?.[0]?.groupId) {
      // 删除group
      if (editorImageScrollDireaction !== "horizontalScroll") {
        arr = tempThoughts.filter(x => x.groupId !== id);
      } else {
        const results = tempThoughts[0].results;
        const filterResults = results.filter((x: any) => x.parentNode !== id);
        if (func.isEmpty(filterResults)) {
          setImageScrollDireaction("verticallyScroll");
        } else {
          arr = [
            {
              ...tempThoughts[0],
              results: filterResults,
            },
          ];
        }
      }
    } else {
      // 删除单个
      tempThoughts.forEach(x => {
        const noDelArr = x.results.filter((r: any) => r.previewId !== id);
        if (!func.isEmpty(noDelArr)) {
          arr.push({
            ...x,
            results: noDelArr,
          });
        }
      });
    }
    // bsf-4912 use setSassUIData
    setSaasUIData(prev => ({ ...prev, output: arr }));
  };

  const getType = useMemo(() => {
    let type = "";
    if (nodeData?.groupDnd?.length) {
      type = nodeData.groupDnd[0].results?.[0]?.type;
    } else {
      type = nodeData?.data?.displayType;
    }
    return typeMap[type] || "default";
  }, [nodeData]);

  const handleMouseLeave = (e: any) => {
    if (type !== "output") return;
    onPreviewItemMouseLeave(e);
  };

  const handleMouseEnter = () => {
    if (type !== "output") return;
    onPreviewItemMouseEnter({
      type: getType,
      remove: () => {
        const result = saasUIDataRef.current.output.find(item => {
          return item.results[0].previewId === id;
        });
        const tempNode = getNodes().find(node => {
          return node.id === result?.results[0].nodeId;
        });
        logEvent("publish_preview_remove_content", { node: tempNode });

        confirmDeleteBox(id);
      },
      container: SortableItemRef.current,
      id,
    });
  };

  return (
    <div
      onMouseLeave={handleMouseLeave}
      onMouseEnter={handleMouseEnter}
      className={css["sortable-item"]}
      ref={SortableItemRef}
      {...sortableItemId}
    >
      <SortableToolbar hideHandle={disabled || isClickAddToContent} sortableProps={sortableProps} onSwitch={onSwitch}>
        {/* <div style={{ wordBreak: "break-word" }}>{JSON.stringify(rect)}</div> */}
        {renderChild()}
      </SortableToolbar>
    </div>
  );
}
